import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import StringFilterPill from './filterpills/stringfilterpill/StringFilterPill';
import NumberFilterPill from './filterpills/numberfilterpill/NumberFilterPill';
import DateFilterPill from './filterpills/datefilterpill/DateFilterPill';
import ListFilterPill from './filterpills/listfilterpill/ListFilterPill';
import AddFilterPill from './filterpills/addfilterpill/AddFilterPill';
import filterDefinitionsPropType from '../filterDefinitionsPropType';
import defaultStyles from './FilterList.module.scss';

class FilterList extends Component {
    renderAdd() {
        return this.props.disabled ? null : (
            <AddFilterPill
                filterDefinitions={ this.props.filterDefinitions }
                filters={ this.props.filters }
                isOpen={ this.props.currentlyOpenFilter === 'ADD_FILTER' }
                openFilter={ this.props.openFilter }
                handleAdd={ this.props.addFilter }
            />
        );
    }

    renderPill(filter, filterDefinition = null, error = null) {
        switch (filter.type) {
            case 'String':
                return (
                    <StringFilterPill
                        disabled={ this.props.disabled }
                        fixed={ this.props.fixed || (filterDefinition && filterDefinition.fixed) }
                        key={ filter.title }
                        title={ filter.title }
                        value={ filter.value }
                        filter={ filter }
                        filterError={ error }
                        isOpen={ filter.title === this.props.currentlyOpenFilter }
                        openFilter={ this.props.openFilter }
                        removeFilter={ this.props.removeFilter }
                        updateFilter={ this.props.updateFilter }
                        filterDefinition={ filterDefinition }
                    />
                );
            case 'Number':
                return (
                    <NumberFilterPill
                        disabled={ this.props.disabled }
                        fixed={ this.props.fixed || (filterDefinition && filterDefinition.fixed) }
                        key={ filter.title }
                        title={ filter.title }
                        value={ filter.value }
                        filter={ filter }
                        filterError={ error }
                        isOpen={ filter.title === this.props.currentlyOpenFilter }
                        openFilter={ this.props.openFilter }
                        removeFilter={ this.props.removeFilter }
                        updateFilter={ this.props.updateFilter }
                    />
                );
            case 'Date':
                return (
                    <DateFilterPill
                        disabled={ this.props.disabled }
                        fixed={ this.props.fixed || (filterDefinition && filterDefinition.fixed) }
                        key={ filter.title }
                        title={ filter.title }
                        value={ filter.value }
                        filter={ filter }
                        filterError={ error }
                        isOpen={ filter.title === this.props.currentlyOpenFilter }
                        openFilter={ this.props.openFilter }
                        removeFilter={ this.props.removeFilter }
                        updateFilter={ this.props.updateFilter }
                        filterDefinition={ filterDefinition }
                    />
                );
            case 'List':
                return (
                    <ListFilterPill
                        disabled={ this.props.disabled }
                        fixed={ this.props.fixed || (filterDefinition && filterDefinition.fixed) }
                        key={ filter.title }
                        title={ filter.title }
                        value={ filter.value }
                        filter={ filter }
                        filterError={ error }
                        isOpen={ filter.title === this.props.currentlyOpenFilter }
                        openFilter={ this.props.openFilter }
                        removeFilter={ this.props.removeFilter }
                        updateFilter={ this.props.updateFilter }
                        getAvailableListValues={
                            () => this.props.getAvailableListValues(filter.title)
                        }
                        filterDefinition={ filterDefinition }
                    />
                );
            default:
                return null;
        }
    }

    render() {
        const { styles } = this.props;
        if (this.props.isDefaults) {
            return (
                <div className={ classnames({
                    [styles.filterListContainer]: true
                }) }
                >
                    { this.props.fixed ? null : this.renderAdd() }
                    { Array.isArray(this.props.filters) && this.props.filters.length
                        ? this.props.filters
                            .slice()
                            .reverse()
                            .map((filter) => this.renderPill(
                                filter,
                                this.props.filterDefinitions
                                    ? this.props.filterDefinitions.find(
                                        (f) => f.title === filter.title
                                    )
                                    : null
                            ))
                        : null }
                </div>
            );
        }
        return (
            <div className={ styles.filterListContainer }>
                { Array.isArray(this.props.filters) && this.props.filters.length
                    ? this.props.filters.map((filter) => this.renderPill(
                        filter,
                        this.props.filterDefinitions
                            ? this.props.filterDefinitions.find((f) => f.title === filter.title)
                            : null,
                        this.props.filterErrors
                            ? this.props.filterErrors.find((e) => e.filter === filter.title)
                            : null
                    ))
                    : null }
                { this.props.fixed ? null : this.renderAdd() }
            </div>
        );
    }
}

FilterList.propTypes = {
    isDefaults: PropTypes.bool,
    fixed: PropTypes.bool,
    disabled: PropTypes.bool,
    filters: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
            PropTypes.arrayOf(PropTypes.oneOfType([
                PropTypes.string
            ])),
            PropTypes.shape({})
        ]).isRequired
    })),
    filterErrors: PropTypes.arrayOf(PropTypes.shape({})),
    filterDefinitions: filterDefinitionsPropType,
    currentlyOpenFilter: PropTypes.string,
    openFilter: PropTypes.func.isRequired,
    updateFilter: PropTypes.func.isRequired,
    removeFilter: PropTypes.func.isRequired,
    addFilter: PropTypes.func.isRequired,
    getAvailableListValues: PropTypes.func.isRequired,
    styles: PropTypes.objectOf(PropTypes.string)
};

FilterList.defaultProps = {
    fixed: false,
    disabled: false,
    isDefaults: false,
    filters: [],
    filterErrors: null,
    filterDefinitions: [],
    currentlyOpenFilter: null,
    styles: defaultStyles
};

export default FilterList;
